import { useEffect, useState } from "react"
import { addPathToDocument } from "config/utils"

type GenericType<T> = T extends string ? string : string[]
interface SignedUrlForImageProps<T extends string | string[]> {
	path: T
	children: (srcUrl: GenericType<T>, loading: boolean) => React.ReactNode
}

export function SignedUrlForImage<T extends string | string[]>({ children, path }: SignedUrlForImageProps<T>) {
	const [srcUrl, setSrcUrl] = useState((Array.isArray(path) ? [] : "") as GenericType<T>)
	const [loading, setLoading] = useState(false)

	const getSignedPath = async (path: string | string[]) => {
		try {
			setLoading(true)
			if (Array.isArray(path)) {
				const urls = await Promise.all(path.map(item => addPathToDocument(item)))

				setSrcUrl(urls as GenericType<T>)
			} else {
				const url = await addPathToDocument(path)
				setSrcUrl(url as GenericType<T>)
			}
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (!!path || path?.length) {
			getSignedPath(path)
		}
	}, [path])

	return <>{children(srcUrl, loading)}</>
}
